import React from 'react'
import injectSheet from 'react-jss'

class ContentContainer extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    const {
      admin,
      children,
      classes,
      small,
    } = this.props

    return (
      <div className={`${classes.mainContent} ${small && 'small'} ${admin && 'admin'}`}>
        <div className={`${classes.gridContainer}`}>
          <div>
            {children}
          </div>
        </div>
      </div>
    )
  }
}

const styles = theme => ({
  mainContent: {
    backgroundColor: theme.colors.secondary_3a,
    minHeight: '100vh',
    padding: `${theme.sizes.header + 5}px 0 100px 0`,
    display: 'flex',
    justifyContent: 'center',
    [theme.media.medium]: {
      padding: `${theme.sizes.headerLarge + 20}px 0 100px 0`,
    },
    '&.small $gridContainer': {
      maxWidth: `${theme.sizes.smallContainer}px`,
    },
    '&.admin': {
      padding: `${theme.sizes.header}px 0 0 0`,
      [theme.media.medium]: {
        padding: `${theme.sizes.headerLarge + 20}px 0 0 0`,
      },
    },
  },
  gridContainer: {
    width: '100vw',
    maxWidth: `${theme.sizes.container}px`,
  },
})

export default injectSheet(styles)(ContentContainer)



// WEBPACK FOOTER //
// ./src/modules/core/components/contentContainer.jsx